import RouterGuard from './_RouterGuards'
import store from '../store'
import ActivityForm from '../components/activities/ActivityForm'
import PrintableActivityList from '../components/activities/PrintableActivityList'
import ActivitySearch from '../components/activities/ActivitySearch'
import SingleActivity from '../components/activities/SingleActivity'
import PrintableOrganizationActivityList from '../components/activities/PrintableOrganizationActivityList'

export default {
  activities: {
    path: '/activity/search',
    name: 'Activity Search',
    component: ActivitySearch,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  },
  printableActivities: {
    path: '/activity/printable',
    name: 'PrintableActivityList',
    component: PrintableActivityList,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  },
  printableOrganizationActivities: {
    path: '/activity/printable/organization',
    name: 'PrintableOrganizationActivityList',
    component: PrintableOrganizationActivityList,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  },
  createAnActivity: {
    path: '/activity/create',
    name: 'Activity Creation',
    props: (route) => ({ query: route.query.q }),
    component: ActivityForm,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  },
  singleActivity: {
    path: '/activity/:id',
    name: 'Single Activity',
    component: SingleActivity,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/activities.js